export const APPLICATION_THEME_LOAD_FAILED = "APPLICATION_THEME_LOAD_FAILED";
export const APPLICATION_THEME_LOAD_SUCCEEDED = "APPLICATION_THEME_LOAD_SUCCEEDED";
